import React from 'react';
import styled from 'styled-components';

const MinerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
`;

export default MinerRow;
